<template>
  <div>
    <div class="label-image">
      <div class="labeled-image">
        <!-- eslint-disable-next-line -->
        <canvas style="z-index:-1;" width="900" height="500" id="canvas" class="labeled-image__double"></canvas>
        <!-- eslint-disable-next-line -->
        <canvas style="z-index:0;" width="900" height="500" id="canvas2" class="labeled-image__double"></canvas>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    PropsBatchType: null, // use in 1,2,3階段
    PropsBatchDate: null, // use in 1,2,3階段
    PropsImgName: null, // use in 1,2,3階段
    PropsBoxTimes: null, // use in 1,3階段
    PropsRoi: null, // use in 1階段
    PropsLevelOne: null, // use in 1階段
    PropsHideBox: null, // use in 1階段
    PropsLevelTwo: null, // use in 2階段
    PropsRectDataFromApi: null, // use in 2階段
    PropsLevelThree: null, // use in 3階段
    PropsLandmark: null, // use in 2 3階段
    PropsDelete: null, // use in 3階段
    PropsDotsDataFromApi: null, // use in 3階段
    PropsSpaceKeydown: null, // use in 2,3 階段
    PropsSwitchPen: null, // use in 3階段
  },
  data() {
    return {
      // use in mouse event
      mouseMovingX: null,
      mouseMovingY: null,
      mouseStartX: null,
      mouseStartY: null,
      mouseEndX: null,
      mouseEndY: null,
      mousedown: false,
      // use in mouse event

      // use in canvas
      imageCanvas: null, // 圖片層
      imageCtx: null, // 圖片層
      drawingCanvas: null, // 畫畫層
      drawingCtx: null, // 畫畫層
      // use in canvas

      // use in 第二階段
      storeRectData: [],
      classDecideColor: {
        person: '#24ceb9',
        face: 'darkorchid',
        head: 'red',
        hand: 'cornflowerblue',
        leg: 'khaki',
        bed: 'green',
        ear: '#EE7700',
        chair: 'red',
        dog: 'khaki',
        cat: 'cornflowerblue'
      },
      // use in 第二階段

      // use in 第三階段
      storeDotData: [],
      landmarkDecideColor: {
        eye: 'red',
        nose: 'green',
        mouth: 'blue',
      },
      // use in 第三階段
    };
  },
  methods: {
    drawImg() {
      const vm = this;
      vm.imageCanvas = document.getElementById('canvas');
      vm.imageCtx = vm.imageCanvas.getContext('2d');
      vm.imageCtx.clearRect(0, 0, 900, 500);
      vm.imageObj = new Image();
      const urlData = { // create img must have
        BatchDate: vm.PropsBatchDate,
        BatchType: vm.PropsBatchType,
        ImgOrAudioName: vm.PropsImgName,
      };
      vm.$store.dispatch('getImgOrAudioWithToken', urlData).then((response) => {
        vm.imageObj.src = URL.createObjectURL(response);
      });
      vm.imageObj.onload = () => {
        const compressionRate = vm.compressResolution(vm.imageObj.width, vm.imageObj.height);
        // eslint-disable-next-line
        vm.imageCtx.drawImage(vm.imageObj, 0, 0, vm.imageObj.width * compressionRate, vm.imageObj.height * compressionRate);
        if (vm.PropsLevelOne) { // 第一階段
          vm.sort();
        } else if (vm.PropsLevelTwo) { // 第二階段
          vm.PropsDataToRectData();
          vm.drawCreatedRect();
        } else if (vm.PropsLevelThree) { // 第三階段
          vm.drawCreatedDot();
          vm.PropsDataToRectData();
          vm.drawCreatedRect();
        }
      };
    },
    sort() { // 第一階段 將label box 分類
      const vm = this;
      for (let i = 0; i < vm.PropsBoxTimes.length; i += 1) {
        if (vm.PropsBoxTimes[i].class === 'head') {
          vm.calculLabelBox(vm.PropsBoxTimes[i].bbox, 'head');
        } else if (vm.PropsBoxTimes[i].class === 'person') {
          vm.calculLabelBox(vm.PropsBoxTimes[i].bbox, 'person');
        } else if (vm.PropsBoxTimes[i].class === 'face') {
          vm.calculLabelBox(vm.PropsBoxTimes[i].bbox, 'face');
        } else if (vm.PropsBoxTimes[i].class === 'leg') {
          vm.calculLabelBox(vm.PropsBoxTimes[i].bbox, 'leg');
        } else if (vm.PropsBoxTimes[i].class === 'bed') {
          vm.calculLabelBox(vm.PropsBoxTimes[i].bbox, 'bed');
        } else if (vm.PropsBoxTimes[i].class === 'hand') {
          vm.calculLabelBox(vm.PropsBoxTimes[i].bbox, 'hand');
        }
      }
      if (vm.PropsRoi) {
        vm.calculLabelBox(vm.PropsRoi, 'roi');
      }
    },
    calculLabelBox(data, type) { // 用 aspect fit rate 轉換原label的解析度
      const vm = this;
      const compressionRate = vm.compressResolution(vm.imageObj.width, vm.imageObj.height);
      vm.x1 = Math.round(data[0] * compressionRate);
      vm.y1 = Math.round(data[1] * compressionRate);
      vm.x2 = Math.round(data[2] * compressionRate);
      vm.y2 = Math.round(data[3] * compressionRate);
      vm.distenx = vm.x2 - vm.x1;
      vm.disteny = vm.y2 - vm.y1;
      vm.drawLabelBox(data, type);
    },
    drawLabelBox(data, type) { // 畫出 label box
      const vm = this;
      const category = {
        head: () => {
          vm.imageCtx.fillStyle = 'red';
          vm.title(type);
          vm.imageCtx.strokeStyle = 'red';
        },
        person: () => {
          vm.imageCtx.fillStyle = '#24ceb9';
          vm.title(type);
          vm.imageCtx.strokeStyle = '#24ceb9';
        },
        face: () => {
          vm.imageCtx.fillStyle = 'darkorchid';
          vm.title(type);
          vm.imageCtx.strokeStyle = 'darkorchid';
        },
        leg: () => {
          vm.imageCtx.fillStyle = 'khaki';
          vm.title(type);
          vm.imageCtx.strokeStyle = 'khaki';
        },
        bed: () => {
          vm.imageCtx.fillStyle = 'green';
          vm.title(type);
          vm.imageCtx.strokeStyle = 'green';
        },
        hand: () => {
          vm.imageCtx.fillStyle = 'cornflowerblue';
          vm.title(type);
          vm.imageCtx.strokeStyle = 'cornflowerblue';
        },
        roi: () => {
          vm.imageCtx.lineWidth = 5;
          vm.imageCtx.fillStyle = '#FF44AA';
          vm.title(type);
          vm.imageCtx.strokeStyle = '#FF44AA';
        },
        chair: () => {
          vm.imageCtx.fillStyle = 'red';
          vm.title(type);
          vm.imageCtx.strokeStyle = 'red';
        },
        cat: () => {
          vm.imageCtx.fillStyle = 'cornflowerblue';
          vm.title(type);
          vm.imageCtx.strokeStyle = 'cornflowerblue';
        },
        dog: () => {
          vm.imageCtx.fillStyle = 'khaki';
          vm.title(type);
          vm.imageCtx.strokeStyle = 'khaki';
        },
      };
      vm.imageCtx.font = '20px Arial';
      category[type]();
      vm.imageCtx.strokeRect(vm.x1, vm.y1, vm.distenx, vm.disteny);
      vm.imageCtx.lineWidth = 1;
    },
    title(type) { // 將label所代表的部位顯示出來
      const vm = this;
      vm.imageCtx.fillRect(vm.x1, vm.y1, `${(type.length + 1) * 10}`, -25);
      vm.imageCtx.fillStyle = 'black';
      vm.imageCtx.fillText(type, `${vm.x1 + 5}`, `${vm.y1 - 5}`);
      // 讓字體有點padding的感覺
    },
    hideLabelBox() { // 隱藏label box
      const vm = this;
      const compressionRate = vm.compressResolution(vm.imageObj.width, vm.imageObj.height);
      if (vm.PropsHideBox === 'Show') {
        if (vm.PropsLevelOne) {
          vm.imageCtx.clearRect(0, 0, 900, 500);
          // eslint-disable-next-line
          vm.imageCtx.drawImage(vm.imageObj, 0, 0, vm.imageObj.width * compressionRate, vm.imageObj.height * compressionRate);
        } else if (vm.PropsLevelThree) {
          vm.drawingCtx.clearRect(0, 0, 900, 500);
          vm.drawCreatedDot();
        }
      } else {
        if (vm.PropsLevelOne) {
          vm.sort();
        }
        if (vm.PropsLevelThree) { // 第三階段
          vm.drawCreatedDot();
          vm.drawCreatedRect();
        }
      }
    },
    // PropsLevelTwo===true 第二階段標記方法
    createDataForParents(rectData) {
      const data = [];
      for (let i = 0; i < rectData.length; i += 1) {
        data.push({
          class: rectData[i].class,
          bbox: [rectData[i].startX, rectData[i].startY, rectData[i].endX, rectData[i].endY],
        });
      }
      return data;
    },

    // PropsLevelTwo===true 第二階段標記方法
    PropsDataToRectData() {
      const vm = this;
      vm.storeRectData = [];
      for (let i = 0; i < vm.PropsRectDataFromApi.length; i += 1) {
        vm.storeRectData.push({
          startX: vm.PropsRectDataFromApi[i].bbox[0],
          startY: vm.PropsRectDataFromApi[i].bbox[1],
          endX: vm.PropsRectDataFromApi[i].bbox[2],
          endY: vm.PropsRectDataFromApi[i].bbox[3],
          class: vm.PropsRectDataFromApi[i].class,
          color: vm.classDecideColor[vm.PropsRectDataFromApi[i].class],
        });
      }
    },
    // PropsLevelTwo===true 第二階段標記方法
    drawCreatedRect() {
      const vm = this;
      const compressRate = vm.compressResolution(vm.imageObj.width, vm.imageObj.height);
      for (let i = 0; i < vm.storeRectData.length; i += 1) {
        vm.drawingCtx.strokeStyle = vm.classDecideColor[vm.storeRectData[i].class];
        vm.drawingCtx.strokeRect(vm.storeRectData[i].startX * compressRate,
          vm.storeRectData[i].startY * compressRate,
          (vm.storeRectData[i].endX - vm.storeRectData[i].startX) * compressRate,
          (vm.storeRectData[i].endY - vm.storeRectData[i].startY) * compressRate);
      }
      const data = vm.createDataForParents(vm.storeRectData);
      vm.$emit('feedbackStoreRectData', data);
    },
    // PropsLevelTwo===true 第二階段標記方法
    drawingRect(event) {
      const vm = this;
      const locate = vm.getPointOnCanvas(vm.imageCanvas, event.clientX, event.clientY);
      vm.mouseMovingX = locate.x;
      vm.mouseMovingY = locate.y;
      if (vm.mousedown === true) {
        vm.drawingCtx.clearRect(0, 0, 900, 500);
        vm.drawingCtx.strokeStyle = vm.classDecideColor[vm.PropsLandmark];
        console.log(vm.PropsLandmark)
        vm.drawingCtx.strokeRect(vm.mouseStartX, vm.mouseStartY,
          vm.mouseMovingX - vm.mouseStartX, vm.mouseMovingY - vm.mouseStartY);
        vm.drawCreatedRect();
      }
    },
    // PropsLevelTwo===true 第二階段標記方法
    StoreRect(event) {
      const vm = this;
      const compressRate = vm.compressResolution(vm.imageObj.width, vm.imageObj.height);
      const locate = vm.getPointOnCanvas(vm.imageCanvas, event.clientX, event.clientY);
      vm.mouseEndX = locate.x;
      vm.mouseEndY = locate.y;
      // eslint-disable-next-line
      if (Math.abs(vm.mouseStartX - vm.mouseEndX) > 20 && Math.abs(vm.mouseStartY - vm.mouseEndY) > 20) {
        var startX = Math.round(vm.mouseStartX / compressRate)
        var startY = Math.round(vm.mouseStartY / compressRate)
        var endX = Math.round(vm.mouseEndX / compressRate)
        var endY = Math.round(vm.mouseEndY / compressRate)
        var x_min = Math.min(startX, endX)
        var y_min = Math.min(startY, endY)
        var x_max = Math.max(startX, endX)
        var y_max = Math.max(startY, endY)

        vm.storeRectData.push({
          startX: x_min,
          startY: y_min,
          endX: x_max,
          endY: y_max,
          class: vm.PropsLandmark,
          color: vm.classDecideColor[vm.PropsLandmark],
        });
      }
    },
    // 第二階段標記方法
    deleteStoredRectData(item) {
      const vm = this;
      vm.storeRectData.splice(vm.storeRectData.indexOf(item), 1);
      vm.drawingCtx.clearRect(0, 0, 900, 500);
      vm.drawCreatedRect();
    },
    // PropsLevelThree===true 第三階段標記方法
    drawDot() {
      if (this.PropsLevelThree === true) {
        const vm = this;
        vm.drawingCtx.fillStyle = vm.landmarkDecideColor[vm.PropsLandmark];
        // 绘制成矩形
        vm.drawingCtx.fillRect(vm.mouseStartX - 3, vm.mouseStartY - 3, 6, 6);
        vm.storeDot();
      }
    },
    // PropsLevelThree===true 第三階段標記方法
    storeDot() {
      const vm = this;
      const eyeArray = vm.storeDotData.filter((item) => item.part === 'eye');
      const noseArray = vm.storeDotData.filter((item) => item.part === 'nose');
      const mouthArray = vm.storeDotData.filter((item) => item.part === 'mouth');
      const compressionRate = vm.compressResolution(vm.imageObj.width, vm.imageObj.height);
      if (vm.PropsLandmark === 'eye' && eyeArray.length < 2) {
        vm.storeDotData.push({
          x: Math.round(vm.mouseStartX / compressionRate),
          y: Math.round(vm.mouseStartY / compressionRate),
          part: this.PropsLandmark,
          color: vm.landmarkDecideColor[vm.PropsLandmark],
        });
        vm.$emit('feedbackStoreDotData', vm.storeDotData);
      } else if (vm.PropsLandmark === 'nose' && noseArray.length < 1) {
        vm.storeDotData.push({
          x: Math.round(vm.mouseStartX / compressionRate),
          y: Math.round(vm.mouseStartY / compressionRate),
          part: this.PropsLandmark,
          color: vm.landmarkDecideColor[vm.PropsLandmark],
        });
        vm.$emit('feedbackStoreDotData', vm.storeDotData);
      } else if (vm.PropsLandmark === 'mouth' && mouthArray.length < 2) {
        vm.storeDotData.push({
          x: Math.round(vm.mouseStartX / compressionRate),
          y: Math.round(vm.mouseStartY / compressionRate),
          part: this.PropsLandmark,
          color: vm.landmarkDecideColor[vm.PropsLandmark],
        });
        vm.$emit('feedbackStoreDotData', vm.storeDotData);
      }
    },
    // PropsLevelThree===true 第三階段標記方法
    drawCreatedDot() {
      const vm = this;
      const compressionRate = vm.compressResolution(vm.imageObj.width, vm.imageObj.height);
      for (let i = 0; i < vm.storeDotData.length; i += 1) {
        vm.drawingCtx.fillStyle = vm.landmarkDecideColor[vm.storeDotData[i].part];
        // eslint-disable-next-line
        vm.drawingCtx.fillRect(vm.storeDotData[i].x * compressionRate - 3, vm.storeDotData[i].y * compressionRate - 3, 6, 6);
      }
    },
    // 第三階段標記方法
    deleteStoreDot() {
      this.storeDotData = [];
      this.drawingCtx.clearRect(0, 0, 900, 500);
      this.$emit('feedbackStoreDotData', this.storeDotData);
    },
    compressResolution(width, height) { // 獲得 900*500（aspect fit rate）圖片壓縮比例
      let rate = 500 / height;
      if (width * rate > 900) {
        rate = 900 / width;
      }
      return rate;
    },
    initMosueEventAndCanvas() { // 初始化二．三階段的滑鼠事件監聽
      const vm = this;
      vm.imageCanvas = document.getElementById('canvas');
      vm.imageCtx = vm.imageCanvas.getContext('2d');
      vm.drawingCanvas = document.getElementById('canvas2');
      vm.drawingCtx = vm.drawingCanvas.getContext('2d');
      vm.drawingCanvas.addEventListener('mousemove', (event) => {
        if (vm.PropsLevelTwo) {
          vm.drawingRect(event);
        }
        if (vm.PropsLevelThree && vm.PropsSwitchPen === 'rect') {
          vm.drawingRect(event);
          vm.drawCreatedDot();
        }
      });
      vm.drawingCanvas.addEventListener('mousedown', (event) => {
        if (vm.PropsLevelTwo && vm.mousedown) {
          vm.drawingCtx.clearRect(0, 0, 900, 500);
          vm.StoreRect(event);
          vm.drawCreatedRect();
          vm.mousedown = false;
        } else if (vm.PropsLevelTwo && !vm.mousedown) {
          vm.createMouseStartLocation(event);
          vm.mousedown = true;
        }
        if (vm.PropsLevelThree && vm.PropsSwitchPen === 'dot') {
          vm.createMouseStartLocation(event);
          vm.drawDot();
        } else if (vm.PropsLevelThree && vm.PropsSwitchPen === 'rect' && vm.mousedown) {
          vm.mousedown = false;
          vm.drawingCtx.clearRect(0, 0, 900, 500);
          vm.StoreRect(event);
          vm.drawCreatedRect();
          vm.drawCreatedDot();
        } else if (vm.PropsLevelThree && vm.PropsSwitchPen === 'rect' && !vm.mousedown) {
          vm.createMouseStartLocation(event);
          vm.mousedown = true;
        }
      });
      vm.drawingCanvas.addEventListener('mouseup', (event) => {
        if (vm.PropsLevelThree && vm.PropsSwitchPen === 'dot') {
          vm.drawingCtx.clearRect(0, 0, 900, 500);
          vm.drawCreatedDot();
          vm.drawCreatedRect();
        }
      });
    },
    getPointOnCanvas(canvas, x, y) { // 獲得在canvas上的座標
      const bbox = canvas.getBoundingClientRect();
      return {
        x: x - bbox.left * (canvas.width / bbox.width),
        y: y - bbox.top * (canvas.height / bbox.height),
      };
    },
    createMouseStartLocation(event) { // 拿到mouse點擊位置
      const vm = this;
      const locate = vm.getPointOnCanvas(vm.imageCanvas, event.clientX, event.clientY);
      vm.mouseStartX = locate.x;
      vm.mouseStartY = locate.y;
    },
  },
  watch: {
    PropsImgName() {
      const vm = this;
      vm.drawImg();
      vm.drawingCtx.clearRect(0, 0, 900, 500);

      // 第二階段
      if (vm.PropsLevelTwo) {
        vm.storeRectData = [];
      }
      // 第三階段
      if (vm.PropsLevelThree) {
        vm.deleteStoreDot();
        vm.storeDotData = vm.PropsDotsDataFromApi;
        vm.$emit('feedbackStoreDotData', vm.storeDotData); // 將第三階段資料emit給父組件
      }
    },
    PropsHideBox() { // 第一階段
      this.hideLabelBox();
    },
    PropsRectDataFromApi() { // PropsLevelTwo===true 第二階段標記方法
      if (this.PropsLevelTwo) {
        this.drawingCtx.clearRect(0, 0, 900, 500);
        this.PropsDataToRectData();
        this.drawCreatedRect();
      } else if (this.PropsLevelThree) {
        this.drawingCtx.clearRect(0, 0, 900, 500);
        this.PropsDataToRectData();
        this.drawCreatedRect();
      }
    },
    PropsDelete() { // PropsLevelThree===true 第三階段標記方法
      if (this.PropsDelete === true) {
        this.deleteStoreDot();
        this.drawCreatedRect();
      }
    },
    PropsSpaceKeydown() {
      const vm = this;
      if (vm.PropsLevelThree) {
        if (vm.PropsSpaceKeydown && vm.mousedown && vm.PropsSwitchPen === 'rect') {
          vm.drawingCtx.clearRect(0, 0, 900, 500);
          vm.mousedown = false;
          vm.$emit('feedbackSpaceKeyDown', false);
          vm.drawCreatedDot();
          vm.drawCreatedRect();
        } else if (vm.PropsSpaceKeydown) {
          vm.$emit('feedbackSpaceKeyDown', false);
        }
      } else if (vm.PropsLevelTwo) {
        if (vm.PropsSpaceKeydown && vm.mousedown) {
          vm.drawingCtx.clearRect(0, 0, 900, 500);
          vm.mousedown = false;
          vm.$emit('feedbackSpaceKeyDown', false);
          vm.drawCreatedRect();
        } else if (vm.PropsSpaceKeydown) {
          vm.$emit('feedbackSpaceKeyDown', false);
        }
      }
    },
  },
  mounted() {
    this.initMosueEventAndCanvas();
  },
};
</script>
